const AbstractResourceController = require("../common/AbstractResourceController");
const NetworkPlacesRenderer = require("./NetworkPlacesRenderer");
const NetworkPlacesListView = require("./NetworkPlacesListView");
const Utils = require("common/Utils");

/**
 * @class
 * @extends {AbstractResourceController}
 * @param resourcesModel {ResourcesModel}
 * @constructor
 */
function NetworkPlacesController(resourcesModel) {
    AbstractResourceController.call(this);

    const RESOURCE_TYPE = "network_place";

    const self = this;

    const super_checkForPrerequisites = this.checkForPrerequisites;
    /**
     * @override
     */
    this.checkForPrerequisites = function(id) {
        const resource = resourcesModel.getResource(id);
        if (!self.isAllowedToLaunch(resource)) {
            return;

        }

        if (Utils.isGreaterThanOrEqualToServerVersion(CudaLaunch.serverConfiguration.version, "7.1.0")) {
            super_checkForPrerequisites.call(this, id);
        } else {
            self.launchResource(resource);
        }
    };

    /**
     * @type {NetworkPlaceLauncher}
     */
    var launcher;
    this.registerLauncher = function(_launcher) {
        launcher = _launcher;
    };

    self.subscribeToChannel("Electron", "show-network-places-view", function() {
        self.showView(listView);
    });
    /**
     * @type {NetworkPlacesListView}
     */
    var listView = new NetworkPlacesListView(this.checkForPrerequisites);

    this.setResourcesView(listView);
    listView.addRenderer(RESOURCE_TYPE, new NetworkPlacesRenderer());

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return [listView];
    };

    /**
     * @override
     * @inheritDoc
     */
    this.getResourceTypes = function() {
        return [RESOURCE_TYPE];
    };

    /**
     * @param {ResourcesModel~ResourceItem} resource the resource to launch
     */
    this.launchResource = function(resource) {
        launcher.launchResource(resource, self);
    };

    /**
     * @override
     * @inheritsDoc
     */
    this.getId = function() {
        return "NetworkPlacesController";
    };
}

Utils.inherits(NetworkPlacesController, AbstractResourceController);

module.exports = NetworkPlacesController;


//////////////////
// WEBPACK FOOTER
// ./network_places/NetworkPlacesController.js
// module id = 107
// module chunks = 0